import type { ISubjectRelations } from '@dakedake/types'
import { useCallback, useState } from 'react'
import { subjectRelationsList } from '@/services'

export default function useSubjectAssociation() {
  const [data, setData] = useState<ISubjectRelations[]>([])

  const getSubjectRelationsList = useCallback(async (params: { sid?: number, aid?: number }) => {
    const res = await subjectRelationsList(params)
    setData(res.data)
  }, [])

  return {
    subjectRelations: data,
    getSubjectRelationsList
  }
}
